<template>
  <report-view :url="downloadUrl">
    <md-field>
      <label>Productgroep</label>
      <md-select v-model="sCatNr" :disabled="sCatNr === null">
        <md-option v-for="c in sCats" :value="c.nr" :key="c.nr">{{ c.name }}</md-option>
      </md-select>
    </md-field>

    <strong>Van:</strong>
    <datepicker v-model="fromDate" :language="datepickerLang" format="dd-MM-yyyy" full-month-name />

    <strong>Tot en met:</strong>
    <datepicker v-model="untilDate" :language="datepickerLang" format="dd-MM-yyyy" full-month-name />
  </report-view>
</template>

<script>
  import Api from '@/api';
  import { Events } from '@wsb/wsb-jsbase';
  import RV from '@/components/base/Reportview';
  import Datepicker from 'vuejs-datepicker';
  import { nl } from 'vuejs-datepicker/dist/locale';

  const _sales = {
    name: 'Sales',
    data() {
      return {
        fromDate: new Date((new Date() - 365 * 24 * 60 * 60 * 1000)),
        untilDate: new Date(),
        datepickerLang: nl,
        sCats: [],
        sCatNr: 0
      };
    },
    created() {
      Api.Get('/Report/Sales/Categories')
        .then(r => {
          this.sCats = r;
        })
        .catch(Events.RaiseExceptionOccurred);
    },
    computed: {
      downloadUrl() {
        return `/Report/Sales?from=${this.fromDate.toISOString()}&until=${this.untilDate.toISOString()}&categoryNr=${this.sCatNr}`;
      }
    },
    components: {
      'report-view': RV,
      Datepicker
    }
  };

  export default _sales;
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/reports/Sales.vue